import "./styles.scss";

import React from "react";
import clsx from "clsx";

import { slugize } from "utils/helpers";

import { socialData } from "data/social";

const Social = ({ isLight }) => {
  return (
    <ul className={clsx("social", isLight && "social--light")}>
      {socialData.map((item, index) => (
        <li key={index}>
          <a href={item.url} target="_blank" rel="noreferrer nofollow">
            <img
              className={slugize(item.alt)}
              src={item.image}
              alt={item.alt}
            />
          </a>
        </li>
      ))}
    </ul>
  );
};

export default Social;
